// frequencyAnalysis.js
// Routines for computing word or phrase frequency

export function getWordFrequencies(text) {
  const words = text.toLowerCase().trim().split(/\s+/);
  const freqMap = {};

  for (let w of words) {
    if (!freqMap[w]) {
      freqMap[w] = 0;
    }
    freqMap[w]++;
  }

  // Convert to array and sort by frequency desc
  const freqArr = Object.entries(freqMap).sort((a, b) => b[1] - a[1]);

  return freqArr;
}

// Extension for 2-word phrases
export function getTwoWordFrequencies(text) {
  const words = text.toLowerCase().trim().split(/\s+/);
  const freqMap = {};

  for (let i = 0; i < words.length - 1; i++) {
    const phrase = `${words[i]} ${words[i + 1]}`;
    if (!freqMap[phrase]) {
      freqMap[phrase] = 0;
    }
    freqMap[phrase]++;
  }

  return Object.entries(freqMap).sort((a, b) => b[1] - a[1]);
}

// Extension for 3-word phrases
export function getThreeWordFrequencies(text) {
  const words = text.toLowerCase().trim().split(/\s+/);
  const freqMap = {};

  for (let i = 0; i < words.length - 2; i++) {
    const phrase = `${words[i]} ${words[i + 1]} ${words[i + 2]}`;
    if (!freqMap[phrase]) {
      freqMap[phrase] = 0;
    }
    freqMap[phrase]++;
  }

  return Object.entries(freqMap).sort((a, b) => b[1] - a[1]);
} 